import { memo } from 'react';
import { Circle, Marker, Polygon } from 'react-leaflet';

import dayjs from 'dayjs';
import L from 'leaflet';

import { DATE_FORMAT } from '../../constants/common';
import { GEOMETRY_TYPE } from '../../constants/map';

import MapTrackingFeatureTooltip from './MapTrackingFeatureTooltip';
import SmoothPolyline from './SmoothLine';
import { FILL_OPACITY, ICON, circleOptions } from './constants';

const IconMarkerDark = new L.Icon({
  iconUrl: require('../../assets/images/marker-pin-dark-small.png'),
  iconRetinaUrl: require('../../assets/images/marker-pin-dark-small.png'),
  iconAnchor: L.Browser.retina ? [10, 10] : [5, 5]
});

const IconMarkerAlert = new L.Icon({
  iconUrl: require('../../assets/images/marker-pin-alert-16px.png'),
  iconRetinaUrl: require('../../assets/images/marker-pin-alert-16px.png'),
  iconAnchor: L.Browser.retina ? [10, 10] : [5, 5]
});

const IconMarkerStart = new L.Icon({
  iconUrl: require('../../assets/images/start-pin.png'),
  iconRetinaUrl: require('../../assets/images/start-pin.png'),
  iconAnchor: L.Browser.retina ? [10, 10] : [5, 5],
  className: 'rg-icon-position'
});

const IconMarkerEnd = new L.Icon({
  iconUrl: require('../../assets/images/end-pin.png'),
  iconRetinaUrl: require('../../assets/images/end-pin.png'),
  iconAnchor: L.Browser.retina ? [10, 10] : [5, 5],
  className: 'rg-icon-position'
});

function MapTrackingFeature({ type, geometry, color, properties, setAnimal }) {
  const tooltipData = [
    { id: 'livestock_id', title: 'Livestock ID', value: properties?.identifier },
    { id: 'eartag_management_id', title: 'Mgmt Tag ID', value: properties?.eartag_management_id },
    {
      id: 'last_reading',
      title: 'Last Reading',
      value: properties?.time ? dayjs(properties.time).format(DATE_FORMAT.DATETIME) : null
    }
  ];

  const navigateToAnimalTrackingPage = () => {
    setAnimal(properties.animal_id);
  };

  let LINE;

  if (type === GEOMETRY_TYPE.POLYGON) {
    LINE = <Polygon fillOpacity={FILL_OPACITY.DEFAULT} color={color} positions={geometry} />;
  }

  if (type === GEOMETRY_TYPE.LINE) {
    LINE = <SmoothPolyline color={color} positions={geometry} />;
  }

  if (type === GEOMETRY_TYPE.POINT) {
    if (properties.animal_id) {
      LINE = (
        <Circle {...circleOptions} center={geometry} eventHandlers={{ click: navigateToAnimalTrackingPage }}>
          <Marker
            draggable={false}
            icon={properties.hasAlerts ? IconMarkerAlert : IconMarkerDark}
            position={geometry}
            eventHandlers={{ click: navigateToAnimalTrackingPage }}>
            <MapTrackingFeatureTooltip data={tooltipData} />
          </Marker>
        </Circle>
      );
    } else {
      LINE = (
        <Circle {...circleOptions} center={geometry}>
          <Marker draggable={false} icon={properties.hasAlerts ? IconMarkerAlert : IconMarkerDark} position={geometry}>
            <MapTrackingFeatureTooltip data={tooltipData} />
          </Marker>
        </Circle>
      );

      // SHOW START & END ICONS //
      if (properties.customIcon) {
        const isEnd = properties.customIcon === ICON.END;
        const icon = isEnd ? IconMarkerEnd : IconMarkerStart;
        const zIndex = isEnd ? 1 : 2;

        LINE = (
          <Circle {...circleOptions} center={geometry}>
            <Marker draggable={false} icon={icon} opacity={0.4} position={geometry} zIndexOffset={zIndex}>
              <MapTrackingFeatureTooltip data={tooltipData} />
            </Marker>
            <Marker draggable={false} icon={icon} position={geometry} zIndexOffset={zIndex}>
              <MapTrackingFeatureTooltip data={tooltipData} />
            </Marker>
          </Circle>
        );
      }

      if (properties.last_reading) {
        LINE = (
          <Circle {...circleOptions} center={geometry}>
            <Marker
              draggable={false}
              icon={properties.hasAlerts ? IconMarkerAlert : IconMarkerDark}
              position={geometry}>
              <MapTrackingFeatureTooltip data={tooltipData} />
            </Marker>
          </Circle>
        );
      }
    }
  }

  return LINE;
}

export default memo(MapTrackingFeature);
